/**
 * Locate the originating element for an event, respecting composed paths.
 */
export function getStartElement(e: Event): HTMLElement | null {
  let startEl: HTMLElement | null = null;

  if (e && typeof (e as MouseEvent).composedPath === 'function') {
    const path = (e as MouseEvent).composedPath();
    for (let i = 0; i < path.length; i++) {
      const node = path[i];
      if (node instanceof HTMLElement) {
        startEl = node;
        break;
      }
    }
  }

  if (!startEl) {
    const raw = e.target;
    startEl =
      raw && raw instanceof HTMLElement
        ? raw
        : raw && (raw as Node).parentElement
          ? (raw as Node).parentElement
          : null;
  }

  return startEl;
}
